import React from 'react';
export default function plusCircle(props) {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width={props.size || "72.656"} height={props.size || "72.656"} style={props.style} viewBox="0 0 72.656 72.656">
  <path d="M37.5-64.453A36.322,36.322,0,0,0,1.172-28.125,36.322,36.322,0,0,0,37.5,8.2,36.322,36.322,0,0,0,73.828-28.125,36.322,36.322,0,0,0,37.5-64.453Zm21.094,40.43a1.763,1.763,0,0,1-1.758,1.758H43.359V-8.789A1.763,1.763,0,0,1,41.6-7.031H33.4a1.763,1.763,0,0,1-1.758-1.758V-22.266H18.164a1.763,1.763,0,0,1-1.758-1.758v-8.2a1.763,1.763,0,0,1,1.758-1.758H31.641V-47.461A1.763,1.763,0,0,1,33.4-49.219h8.2a1.763,1.763,0,0,1,1.758,1.758v13.477H56.836a1.763,1.763,0,0,1,1.758,1.758Z" transform="translate(-1.172 64.453)"/>
</svg>)
}

